import { action, Action, createTypedHooks } from 'easy-peasy';

export interface IAICreateTipModel {
    isShow: boolean;
    tip: string;
    target: string;
    show: Action<IAICreateTipModel, { tip: string; target?: string }>;
    hide: Action<IAICreateTipModel>;
}

export const aiCreateTipModel: IAICreateTipModel = {
    isShow: false,
    tip: '',
    target: '',
    show: action((state, payload) => {
        state.tip = payload.tip;
        state.target = payload.target ?? '';
        state.isShow = true;
    }),
    hide: action((state) => {
        state.isShow = false;
        state.tip = '';
        state.target = '';
    }),
};

const typedHooks = createTypedHooks<{
    aiCreateTipModel: IAICreateTipModel;
}>();

export const useStoreState = typedHooks.useStoreState;
export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
